import { KeyedError } from '@zorro/common-utils';
import { Title } from '@zorro/design-system/v2/Title';
import { DataTable, Stack } from '@zorro/web/design-system';

type ErrorsTableProps = {
  tableTitle: string;
  isBulk: boolean;
  shouldHideOnSingle?: boolean;
  errors?: KeyedError[];
};

const ErrorsTable = ({
  tableTitle,
  isBulk,
  shouldHideOnSingle = true,
  errors,
}: ErrorsTableProps) => {
  const defaultIdAccessor = 'key';

  if ((shouldHideOnSingle && !isBulk) || !errors || errors.length === 0) {
    return null;
  }

  const columns = [
    { accessor: defaultIdAccessor, title: tableTitle },
    { accessor: 'error', title: 'Error message' },
  ];

  return (
    <Stack gap="xs">
      <Title order={3}>Errors</Title>
      <DataTable
        columns={columns}
        idAccessor={defaultIdAccessor}
        records={errors}
      />
    </Stack>
  );
};

export { ErrorsTable };
